import {appendPaginationQueryParamsToUrl} from "../utils";

export default host => (options) => appendPaginationQueryParamsToUrl(`${host}/contentCreators/exportLink`, {...options, alreadyHasQueryParams: false});
